<template>
<div>
    <button v-on:click="save()" type="button" class="btn btn-primary">追加</button>
</div>
</template>

<script>
    export default {
        mounted() {
            // console.log('Component mounted.')
        },
        data: function() {
            return {
            }
        },
        methods: {
            save() {
                this.$emit('data-saved')
            }
        }
    }
</script>
